import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageTextArea } from '../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, update } from '../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const AccessAreasEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { areaId } = useParams();
    
    useEffect(() => {
        getOne(`/admin/access/areas/`, areaId).then(response => {
            setMetadata(response.data.metadata);
            setData(response.data.data);
        }).catch(error => {
            toast.error("Error fetching access area: " + error.message, {});
        });
    }, [areaId]);

    const handleSave = () => {
        update(`/admin/access/areas/`, areaId, {data: data}).then(() => {
            navigate(`/admin/access/areas`);
        }).catch(error => {
            toast.error("Error updating access area: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/admin/access/areas`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageTextField 
                        label="Name" 
                        id="name" 
                        onChange={onChange} 
                        value={data.name} 
                        required
                    />
                    <EditPageTextArea 
                        label="Description" 
                        id="description" 
                        onChange={onChange} 
                        value={data.description}
                        rows={3}
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default AccessAreasEdit; 